<template>
  <div class="lead-card" v-bind:class="{ 'duplicates' : lead.duplicates}">
    <div class="lead-card-title">
      {{lead.name}}
    </div>
    <div class="lead-card-source">
      {{lead.source || 'N/A'}}
    </div>
    <div style="padding-top: 5px"></div>
    <div class="row" style="margin: 0">
      <div style="padding-left: 15px"></div>
      <div class="lead-card-value" :class="handleClassByStatus">
        <span ><i class="fa fa-user"></i> • {{ lead.value }}€ </span>
      </div>
      <span v-if="lead.status.id === this.STATUS_NO_INTEREST || lead.status.id === this.STATUS_INVALID" class="text--bold text-lost">&nbsp; {{$t('leads-web.leads.result.lost')}}</span>
      <span v-if="lead.status.id === this.STATUS_VALID_INTEREST" class="text--bold text-win">&nbsp; {{$t('leads-web.leads.result.win')}}</span>
      <span v-if="lead.duplicates" class="text--bold duplicates-text"> <i class="fa fa-exclamation-triangle"></i> {{$t('leads-web.leads.duplicates')}}</span>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    lead: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      STATUS_INVALID: 1,
      STATUS_NOT_CONFIRMED: 2,
      STATUS_VALID_INTEREST: 3,
      STATUS_NO_INTEREST: 4,
      STATUS_NO_INTEREST_MARKETING: 5,
      STATUS_OPERATOR: 6
    }
  },
  computed: {
    handleClassByStatus () {
      if (this.lead.status) {
        if (this.lead.status.id === this.STATUS_NOT_CONFIRMED) return 'lead-status-not-confirmed'
        if (this.lead.status.id === this.STATUS_INVALID) return 'lead-status-invalid'
        if (this.lead.status.id === this.STATUS_VALID_INTEREST) return 'lead-status-valid-interest'
        if (this.lead.status.id === this.STATUS_OPERATOR) return 'lead-status-operator'
        if (this.lead.status.id === this.STATUS_NO_INTEREST) return 'lead-status-invalid'
        if (this.lead.status.id === this.STATUS_NO_INTEREST_MARKETING) return 'lead-status-valid-interest'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lead-card {
  border-radius: 10px;
  background-color: white;
  height: 120px;
}

.duplicates {
 border: 2px solid #FFD443;
}

.duplicates-text {
  color:#FFD443;
  padding-left: 20px;
  font-size: 14px;
}

.lead-card-title {
  padding-top: 15px;
  padding-left: 15px;
  font-weight: bold;
  font-size: 18px;
  color: #484949;
}

.lead-card-source {
  padding-left: 15px;
  padding-top: 5px;
  font-size: 15px;
  color: #D4D4D4;
}

.lead-card-value {
  border-radius: 25px;
  text-align: center;
  width: 75px;
}

.lead-status-not-confirmed {
  background-color: #FFD443;
  color: white;
}

.lead-status-operator {
  background-color: #D4D4D4;
  color: #6E6E6E;
}

.lead-status-valid-interest {
  background-color: #29C4AA;
  color: white;
}

.lead-status-invalid {
  background-color: #C42929;
  color: white;
}

.text-lost {
  color: #C42929;
}

.text-win {
  color: #29C4AA;
}
</style>
